import { render, staticRenderFns } from "./SubscriptionGiftCouponRedeem.vue?vue&type=template&id=8f34ef86&lang=pug&"
import script from "./SubscriptionGiftCouponRedeem.vue?vue&type=script&setup=true&lang=js&"
export * from "./SubscriptionGiftCouponRedeem.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports